import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const H = ({ children }) => (
  <h2 className="text-lg font-bold text-white mt-8 mb-3">{children}</h2>
);
const P = ({ children }) => (
  <p className="text-sm text-[#cbd5e1] leading-relaxed mb-3">{children}</p>
);

export const LegalPage = ({ title, subtitle, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${title} | MP Coaching`;
  }, [title]);

  return (
    <main data-testid="legal-page" className="min-h-screen bg-[#0d0718] px-6 py-16">
      <div className="max-w-3xl mx-auto">
        <Link to="/" data-testid="legal-back-home"
          className="inline-flex items-center gap-2 text-xs text-[#a78bfa] hover:text-white mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4" /> Torna alla home
        </Link>
        <h1 className="display-font text-3xl md:text-5xl uppercase text-white mb-2">{title}</h1>
        {subtitle && <p className="text-xs text-[#94a3b8] mb-6">{subtitle}</p>}
        <div className="rounded-2xl bg-[#120a21] border border-[#2d1b4e] p-6 md:p-8">
          {children}
        </div>
      </div>
    </main>
  );
};

export const LegalH = H;
export const LegalP = P;
